<template id="drilldown-report-page">
  <section>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5">
        <div class="card">
          <div class="card-header text-left">
            {{repTitle}}
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div>
                <table width="65%">
                  <tr>
                    <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{key}}</th>
                    <b>Generic Search</b>
                  </tr>
                  <tr>
                    <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                      <v-select multiple v-bind:key="key" v-model="selectVal[rowsDataDimKeys[index]]" :options="options[rowsDataDimKeys[index]]">
                        <option >All</option>
                        <option :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>
                      </v-select>
                    </td>
                    <input type="text" v-model="filterValue" placeholder="Search">
                  </tr>
                </table>
              </div>
              <br>
              <div class="grid-container">
                <table class="table table-bordered table-hover">
                  <thead class="thead-dark" align="center">

                  <tr>
                    <th></th>
                    <th v-for="(col,index) in headerColumns[1]" v-bind:key="col">
                      {{col}}
                      <a href="#" @click="sortBy(Rcolumns[index])">
                        <i class="fa" v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]" ></i>
                      </a>
                    </th>
                    <th>Action</th>
                    <th>Approval Status</th>
                    <th>Assign</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(rowd,idx) of filteredItems ">
                    <tr id="row" v-bind:key="idx" :class="getClass(`${rowd['rd6']}`)">

                      <td><span  @click=" submenuParam1==='G01' ? loadLevelData(...[[rowd.rd1l1_id]]) : loadLevelData(...[[rowd.rd1l1_name]])" ><span
                          class="offset-md-0">+</span></span>
                      </td>
                      <td :class="{'text-right' : col.startsWith('rm')}"  v-for="col in Rcolumns" v-bind:key="col">{{rowd[col]}}</td>

                      <td>
<!--                        <template v-if="roleName == approval.approval_data[0].approvalType"> -->
<!--                        <template v-if=" rowd['rd1l1_name'] == syspk ">-->
                        <span v-for="(ai,index) in currentMenuActionIconsData[1]" :key="index">
          <span  v-on:click="handleActionIconFunctionCall(ai.functionName,index,rowd['rd1l1_name'],ai.syspk)">
              <i id="first_approve"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:13px; padding-left:5px; "
                 v-bind:style=" (ai.syspk == icon_syspk)  && firstApproverClicked &&  rowd['rd1l1_name'] == row_syspk ?{'color':'green'} : {'color':'blue'}">
              </i>

                       </span>
<!--                       <span v-if="ai.syspk == syspk ">
                        <i v-bind:style=" (ai.syspk == syspk)  ?{'color':'green'} : {'color':'red'}">
                        </i></span>-->
                          </span>
<!--                        </template>-->
       </td>
<!--              <td>
             <span v-for="(ai,index) in approval.approval_data" :key="index">
             <span v-if="rowd['rd1l1_name'] == ai.mdm_record_syspk ">
               &lt;!&ndash;             <span v-on:click="approve(rowd['rd1l1_name'])">&ndash;&gt;
              <i v-bind:class="ai.icon"  style=" font-size:13px; padding-left:1px;  "
              v-bind:style="{'color':ai.color}">
           </i>
           </span>
        </span>
      </td>-->
                      <td>
             <span v-for="(ai,index) in mdmRecordApproval" :key="index">
             <span v-if="rowd['rd1l1_name'] == ai.approval.mdm_record_syspk ">
               <!--             <span v-on:click="approve(rowd['rd1l1_name'])">-->
              <i v-bind:class="ai.approval.icon"  style=" font-size:13px; padding-left:1px;  "
                 v-bind:style="{'color':ai.approval.color}"
                 :title="ai.approval.approval_type">
           </i>
           </span>
        </span>
                      </td>

                      <td><span v-if="rowd.assign==null">- NA -</span>
                        <span v-if="rowd.assign!=null">{{rowd.assign}}</span></td>

                    </tr>

                    <tr v-if="whatL1 === (submenuParam1==='G01' ? rowd.rd1l1_id : rowd.rd1l1_name)" class="table-info" v-bind:key="`c-${idx}`">
                      <th> </th>
                      <template v-for="col in headerColumns[2]">
                        <th v-bind:key="col"><span class="offset-md-1"> {{col}} </span></th>
                      </template>
                      <th>Action</th>
                      <th>Assign</th>
                    </tr>

                    <template v-for="(first,idx) of firstDrilldownData">
                      <tr v-bind:key="`first-${idx}`" v-if="whatL1 === (submenuParam1==='G01' ? rowd.rd1l1_id : rowd.rd1l1_name)">
                        <td>
                          <a  @click=" submenuParam1==='G01' ? loadLevelData(...[Array(rowd.rd1l1_id,first.rd1l2_name)]) : loadLevelData(...[Array(rowd.rd1l1_name,first.rd1l2_name)])">
                            <span class="offset-md-1">&gt;&gt;</span>
                          </a>
                        </td>
                        <td :class="{'text-right' : col2.startsWith('rm')}" v-for="col2 in R2columns" v-bind:key="col2"><span class="offset-md-1">{{first[col2]}}</span></td>

                        <td>
                          <!--                          <span @click="commentBox(first['rd1_id'])">
                                                              <i class="fa fa-lg fa-comments text-primary"></i>
                                                          </span>
                                                    <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                              <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                          </span>
                                                    <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                  <i class="fa fa-user-cog text-info"></i>
                                                              </span>
                                                    <span @click="accept(rowd['rd1l1_name'])" title="Accept">
                                                              <i class="fas fa-thumbs-up"></i>
                                                            </span>
                                                    <span @click="reject(rowd['rd1l1_name'])" title="Reject">
                                                              <i class="fas fa-thumbs-down"></i>
                                                            </span>-->
                          <span v-for="(ai,index) in currentMenuActionIconsData[2]" :key="index">
          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index,rowd['rd1l1_name'])">
              <i v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px; color:skyblue">
              </i>
          </span>
        </span>
                          <!--                                  <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">-->
                          <!--                                    <i class="fa fa-download text-info"></i>-->
                          <!--                                  </a></td>-->
                        <td v-b-tooltip.hover title="Assign">
                          <span data-ng-if="rowd.assign==null">- NA -</span>
                          <span data-ng-if="rowd.assign!=null">{{rowd.assign}}</span>
                        </td>
                      </tr>
                      <tr v-if="whatL1 === (submenuParam1==='G01' ? rowd.rd1l1_id : rowd.rd1l1_name) && whatL2 === (first.rd1l2_name ? first.rd1l2_name:false)" class="table-primary"
                          v-bind:key="`second-${idx}`">
                        <th></th>

                        <template v-for="col in headerColumns[3]">
                          <th v-bind:key="col"><span class="offset-md-2"> {{col}} </span></th>
                        </template>
                        <th>Action</th>
                        <th>Assign</th>
                      </tr>
                      <template v-for="(snd,idx) of secondDrilldownData">
                        <tr v-bind:key="`second2-${idx}`"
                            v-if="whatL1 === (submenuParam1==='G01' ? rowd.rd1l1_id : rowd.rd1l1_name) && whatL2 === (first.rd1l2_name ? first.rd1l2_name:false)">


                          <td><span class="offset-md-2">&#8680;</span></td>
                          <td :class="{'text-right' : col3.startsWith('rm')}"  v-for="col3 in R3columns" v-bind:key="col3"> <span class="offset-lg-2"> {{snd[col3]}}</span></td>

                          <td>
                            <!--
                                                        <span @click="commentBox(snd['rd1_id'])">
                                                                    <i class="fa fa-lg fa-comments text-primary"></i>
                                                                </span>
                                                        <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                                    <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                                </span>
                                                        <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                        <i class="fa fa-user-cog text-info" style="padding:5px"></i>
                                                                    </span>
                            -->
                            <span v-for="(ai,index) in currentMenuActionIconsData[3]" :key="index">
          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
              <i v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px; color:skyblue">
              </i>
          </span>
        </span>

                            <!--                                      <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">-->
                            <!--                                        <i class="fa fa-download text-info"></i>-->
                            <!--                                      </a>-->
                          </td>
                          <td>
                            <span data-ng-if="rowd.assign==null">- NA -</span>
                            <span data-ng-if="rowd.assign!=null">{{rowd.assign}}</span>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </template>
                  <!-- <tr v-for ="header in headerColumns" v-bind:key="header" >
                  <td v-for="col in header" v-bind:key="col"> {{col }}</td>
                  <td> {{header}}</td></tr>-->

                  </tbody>
                </table>
              </div>
              <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
                <b-form-group label="Comment">
                  <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                </b-form-group>
              </b-modal>

              <b-modal ref="tag-box" @ok="reject_mdm('')" :title="tagTitle">
                <b-form-group label="Tagging">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate

                </b-form-group>
                <b-form-group label="Comment">
                  <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                </b-form-group>
              </b-modal>

              <b-modal ref="assign-box" @ok="postAssign()" :title="tagTitle">
                <b-form-group label="Assign">
                  <select v-model="assigned" >
                    <!--<option value="Andy">Andy</option>
                    <option value="Sarah">Sarah</option>
                    <option value="Roger">Roger</option>
                    <option value="Mark">Mark</option>
                    <option value="Kane">Kane</option> -->
                    <option v-for="ov in userData" :key="ov.userName" :value="ov.firstName"> {{ov.firstName}}</option>
                  </select>
                </b-form-group>
                <b-form-group label="Comment">
                  <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                </b-form-group>
              </b-modal>
              <b-modal ref="accept-box" @ok="loadReportlevel1()" title="Accept Dialog">
                <b-form-group label="Accept">
                  <p> Accept the Item</p>
                </b-form-group>
              </b-modal>
              <b-modal ref="reject-box" @ok="loadReportlevel1()" title="Reject Dialog">
                <b-form-group label="Reject">
                  <p> Reject the Item</p>
                </b-form-group>
              </b-modal>

            </div>
          </div>
        </div>
      </div>
    </div>
   <!-- <b-modal id="modal-xl" size="xl" ref="validate-row-box" @ok="updateRecord()" :title="repTitle">

      <b-form-group  :label="rowd.rd1l1_name==1963?'Check the rows for duplication':'No Matching Record found'">
        &lt;!&ndash;<b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                required
        ></b-form-input>&ndash;&gt;
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="thead-dark">
            <tr class="text-center">

              <th v-for="(col, index) in columns" v-bind:key="index">
                {{col}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>

              <td style="color:blue" v-for="(col, index) in columns" v-bind:key="index">
                {{rowd[Rcolumns[index]]}}

              </td>
            </tr>
            <template v-if="rowd['syspk']==20">
              <tr v-for="er in 2" v-bind:key="er">

                <td style="color:darkgoldenrod" v-for="(col, index) in columns" v-bind:key="index">
                  {{rowd[Rcolumns[index]]}}
                </td>


              </tr>
            </template>
            <span v-else>
                      <h4>No Matching record found...</h4>
                      </span>
            </tbody>
          </table>

        </div>
      </b-form-group>
    </b-modal>
    <b-modal ref="success-box"  :title="formTitle">
      <b-form-group label="">
        <h4 style="color:darkblue">Record Added Successfully.</h4>
      </b-form-group>
    </b-modal>-->
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'


export default {
  name: 'drilldown-report-page',
  props: {
    viz1: Object,
  },
  data: function () {
    return {
      file: '',
      output: [ ],
      roleName: '',
      icon_syspk: '',
      row_syspk: '',
      icon_color: '',
      firstApproverClicked: false,
      currentMenuActionIconsData: [],
      levelicons: [],
      iconOnChangeFlag: [],
      repTitle:'',
      keys: [ ],
      customerData: [],
      submenuParam1: null,
      firstDrilldownData: [],
      secondDrilldownData: [],
      reportDataConfig: { },
      retid: [],
      levels: [],
      whatLA: [],
      whatL1: null,
      whatL2: null,
      level1: [],
      level2: [],
      levelId: 1,
      repDataDp: [],
      rowsdata: [],
      icons: [],
      levelColumns: [],
      headerColumns: [],
      funCallParamArr:[],
      clickSymbolArr:[],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      cmnt: "",
      annotations: [],
      annotationTitle: "",
      picked:"",
      assigned:"",
      userData:{},
      tagTitle: "",
      dudepData: [],
      mdmRecordApproval: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },

     /*   approval: {
      "approval_data":[
        {"mdm_record_syspk":1963,"approvalType":"CategoryManager", "approvalTypeLevel":1,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1963,"approvalType":"CategoryManager", "approvalTypeLevel":2,"color":"yellow","icon":"fas fa-circle"},
        {"mdm_record_syspk":1963,"approvalType":"BrandManager", "approvalTypeLevel":1,"color":"grey","icon":"fas fa-square"},
        {"mdm_record_syspk":1963,"approvalType":"GST", "approvalTypeLevel":1,"color":"grey","icon":"fas fa-star"},

        {"mdm_record_syspk":1964,"approvalType":"CategoryManager", "approvalTypeLevel":1,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1964,"approvalType":"CategoryManager", "approvalTypeLevel":2,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1964,"approvalType":"BrandManager", "approvalTypeLevel":1,"color":"yellow","icon":"fas fa-square"},
        {"mdm_record_syspk":1964,"approvalType":"GST", "approvalTypeLevel":1,"color":"grey","icon":"fas fa-star"},

        {"mdm_record_syspk":1965,"approvalType":"CategoryManager", "approvalTypeLevel":1,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1965,"approvalType":"CategoryManager", "approvalTypeLevel":2,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1965,"approvalType":"BrandManager", "approvalTypeLevel":1,"color":"yellow","icon":"fas fa-square"},
        {"mdm_record_syspk":1965,"approvalType":"GST", "approvalTypeLevel":1,"color":"green","icon":"fas fa-star"},

        {"mdm_record_syspk":1966,"approvalType":"CategoryManager", "approvalTypeLevel":1,"color":"red","icon":"fas fa-circle"},
        {"mdm_record_syspk":1966,"approvalType":"CategoryManager", "approvalTypeLevel":2,"color":"grey","icon":"fas fa-circle"},
        {"mdm_record_syspk":1966,"approvalType":"BrandManager", "approvalTypeLevel":1,"color":"grey","icon":"fas fa-square"},
        {"mdm_record_syspk":1966,"approvalType":"GST", "approvalTypeLevel":1,"color":"grey","icon":"fas fa-star"},

        {"mdm_record_syspk":1967,"approvalType":"CategoryManager", "approvalTypeLevel":1,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1967,"approvalType":"CategoryManager", "approvalTypeLevel":2,"color":"green","icon":"fas fa-circle"},
        {"mdm_record_syspk":1967,"approvalType":"BrandManager", "approvalTypeLevel":1,"color":"green","icon":"fas fa-square"},
        {"mdm_record_syspk":1967,"approvalType":"GST", "approvalTypeLevel":1,"color":"green","icon":"fas fa-star"}
      ]
    }*/
    }
  },
  created: function () {
    //this.loadCustomer()
    this.loadReportlevel1()
    this.listenToRouter()
    //this.loadConfig()
  },

  computed: {
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      var intmdtColumns = Object.keys(this.rowsdata[0])
      var arr = intmdtColumns.filter(function (item) { return item !== "assign"})
      return arr;
    },
    "R2columns": function columns() {
      if (this.firstDrilldownData.length == 0) {
        return [];
      }
      var intmdt2Columns = Object.keys(this.firstDrilldownData[0])
      var arr2 = intmdt2Columns.filter(function (item) { return item !== "assign"})
      return arr2;
    },
    "R3columns": function columns() {
      if (this.secondDrilldownData.length == 0) {
        return [];
      }
      var intmdt3Columns = Object.keys(this.secondDrilldownData[0])
      var arr3 = intmdt3Columns.filter(function (item) { return item !== "assign"})
      return arr3;
    },

    "orderedData": function () {
      let result=this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd1.includes(this.filterValue));

      }

      return _.orderBy(result, this.sortKey, this.sortOrder)

    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {
          if(this.selectVal[key]) {
            keep =
                keep &&
                (this.selectVal[key].length == 0 ||
                    this.selectVal[key].includes(item[key]));
          }
        });

        return keep;
      });
      if (this.filterValue) {
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null )&& obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))

        );

      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals",vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ",options[key]);
      });

      return options;
    }


  },

  methods: {
    sortBy: function(key) {
      console.log("The sort Key is ",key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey=key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    getClass(a) {
      if (a=='Level3') {
        //this.class="first"
        return 'third'
      }
      if (a=='Level2') {
        //this.class = "second"
        return 'second'
      }
      if(a=='Level1') {
        //this.class = "third"
        return 'first'
      }
    },
    /* downloadFile: function (file_name) {
             console.log(file_name, 'is the name')
       axios.get(`/api/file_exists_processed?fileName=${file_name}`)
           .then(function (resp) {
             if (resp.data.exists) {
               console.log(file_name, 'is the name2')

               return `http://localhost:9888/${file_name}`
              // return `http://139.59.58.160:9888/${file_name}`
             } else {
              alert("File does not Exists")
             }
           }, function () {
             alert('Error in checking file present status');
           })
       },*/
    handleActionIconFunctionCall(fnName, index,x,y) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      console.log("Handle function called with func name", fnName, this.iconOnChangeFlag,x,y)
      this[fnName](x,y)
    },
    downloadFile: function (file_name) {
      console.log(file_name, 'is the name')
      // window.location= `http://localhost:9888/${file_name}`
      window.location= `http://139.59.58.160:9888/${file_name}`
    },
    updateRecord:function(row){

      console.log("Entered validate function",row)
      this.$refs["success-box"].show();
    },
    loadDudep: function () {
      let url = '/api/dedup-get'
      axios.get(url)
          .then(res => {
            this.dudepData = res.data
            console.log("ALl dedup data", this.dudepData)
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
    //Put/Update Request
    accept: function (x) {
      this.$refs["accept-box"].show();
      if(x) {
        console.log('Testing update request', x)
        axios.post('/api/dedup-update/' + x + '/Accept')
            .then(response => {
              this.loadReportlevel1()
              console.log('Data Updated successfully', response)
            })
            .then(this.loadDudep(), e => {
              console.error('error in Updating Record', e)
            })
      }
    },
    reject: function (x) {
      this.$refs["reject-box"].show();
      if(x) {
        axios.post('/api/dedup-update/' + x + '/Reject')
            .then(response => {
              this.loadReportlevel1()
              console.log('Data Updated successfully', response)
            })
            .then(this.loadDudep(), e => {
              console.error('error in Updating Record', e)
            })
      }
    },
    loadMDMRecordApproval: function () {
      let url = '/api/mdmRecordTrail-get'
      axios.get(url)
          .then(res => {
            this.mdmRecordApproval = res.data
            console.log("ALl mdmRecordApproval data", this.mdmRecordApproval[0].approval.approval_role)
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
     changeColor : function() {
  document.getElementById("circle").style.color = "red";  },

    approve: function (x,y) {

    /*  const heart = document.getElementById('heart');
      heart.addEventListener('click', function() {
        //heart.style.color = "#66c144";
        heart.classList.toggle('red');
      });*/
     // this.$refs["accept-box"].show();
    /*  var garbage = document.getElementById("first_approve");

      garbage.addEventListener("click",function(){
        garbage.style.color = "#66c144";
      });*/
    /*  var y = document.getElementById("first_approve").getElementsByTagName("td");
 console.log("length:",y.length)
      for (var i = 0; i < y.length; i++) {
        //var cell = y[i]
      //  var bgc = cell.getAttribute('bgcolor')
        //if (bgc) {
          y[i].style.color = "green"
        //}
      }*/
     // x[0].innerHTML = "i want to change my cell color";
     // y.style.color = "green";
      this.icon_syspk=y;
      this.row_syspk=x;

      if(x) {
        //if(this.mdmRecordApproval[0].approval.approval_status == null) {
        console.log('Testing update request', x,this.syspk)
        axios.post('/api/mdmRecordApproval-update/' + x + '/Accept')
            .then(response => {
              this.loadReportlevel1()
              console.log('Data Updated successfully', response)
             // alert('Accepted!!')
            })
            .then(this.loadMDMRecordApproval(), e => {
              console.error('error in Updating Record', e)
            })
       // this.currentMenuActionIconsData[1].iconId
        this.icon_color = "green"
    //     document.getElementById("first_approve").style.color = "green";

        // document.getElementById("row").style.color="green";
       // alert(Cells[0].innerText);
        this.firstApproverClicked = true;
      //  this.$refs["validate-row-box"].show();

      }
    },
    reject_mdm: function (x) {
     // this.$refs["reject-box"].show();
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the tagBox function(${x},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = x;
      this.tagHeader = "User Tagging";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["tag-box"].show();

      if(x) {
        axios.post('/api/mdmRecordApproval-update/' + x + '/Reject')
            .then(response => {
              this.loadReportlevel1()
              console.log('Data Updated successfully2', response)
            })
            .then(this.loadMDMRecordApproval(), e => {
              console.error('error in Updating Record', e)
            })
        // document.getElementById("first_approve").style.color = "red";
      }
      this.icon_color = "red"

//----------
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        tagStatus: this.picked,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
              data.annotation='';

          },
          (e) => {
            //this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
            this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is1", menu, subMenu,this.pg,this.viz1,data);

     // this.cmt ='';
    //  data.annotation='';
     // this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
        this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", "Success",this.$store.state.deviceType);



    },
    assignBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the assignBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Assignment";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["assign-box"].show();
      axios.get("/api/user").then(res => {
            this.userData = res.data
          },
          err => {
            console.log('Error Fetching data', err)
          })
    },
    postAssign: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        assignedTo: this.assigned,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);
      this.loadReportlevel1();
      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success",this.$store.state.deviceType);
    },
    tagBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the tagBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Tagging";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["tag-box"].show();
    },
    postTagging: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        tagStatus: this.picked,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success",this.$store.state.deviceType);
    },
    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success",this.$store.state.deviceType);
    },

    loadLevelData: function (l1A) {

      var l1 = l1A[0]
      var l2 = l1A[1]
      console.log('Level 1 Data', l1A)
      var array1 = [...Array(5)]
      console.log("Array",Object.getOwnPropertyNames(array1))
      if (_.isEqual(this.whatLA, l1A)){
        this.whatLA = null
        this.whatL1 =null
        this.whatL2 =null
      } else {
        this.whatLA = [...l1A]
        this.whatL1 = l1
        this.whatL2 = l2
        //Post Request
        var LPA = []
        var arrayleng = l1A.length
        LPA.push(this.$route.params.menuId)
        LPA.push(this.$route.params.submenuId)
        LPA.push('level'+ ++arrayleng)
        LPA.push(...l1A)
        console.log("NEW LEVEL PARAM ARRAY",LPA,(l1A.length)++)
        axios.post('/api/repLevelData', LPA)
            .then(res => {
              if (arrayleng ==2){
                this.firstDrilldownData = res.data
                console.log("Post API Called",this.firstDrilldownData)
              }
              else if (arrayleng ==3){
                this.secondDrilldownData = res.data
                console.log('Second DrillDown Data Are', this.secondDrilldownData)

              }
            }, err => {
              console.log('Error Fetching data', err)
            })
        console.log("Outside if cond POst API", this.firstDrilldownData)
        console.log("Outside if cond POst API", this.secondDrilldownData)

      }

    },

    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns= []
        setTimeout(() => {
          $this.loadReportlevel1()
        }, 300)

      })
    },

    loadReportlevel1: async function () {
      let menuParam = this.$route.params.submenuId
      let submenuParam = this.$route.params.submenuId
      console.log('ddrn','loading state');this.$store.dispatch("loadState").then(() => {

        let actionIconsData = this.$store.state.actionIcons
        console.log("actions:", actionIconsData)

        this.submenuParam1 = submenuParam
        this.funCallParamArr = ['True', Array('True', 'rowd.rd1l1_id'), Array('True', 'rowd.rd1l1_id', 'rowd.rd1l2_name')]
        this.clickSymbolArr = ['+', '&gt;&gt;', '&#8680;']

        //Get Request
        axios.get('/api/reportConfigColumn/' + menuParam)
            //      axios.get('/api/reportConfigColumn/'+ menuParam + '/' +submenuParam)
            .then(res => {
              this.drilldowndata = res.data
              this.reportDataConfig = this.drilldowndata
              console.log("REport PAge DATA config", this.reportDataConfig)
              this.repTitle = this.drilldowndata.columns[0].reportName
              this.columns = this.drilldowndata.columns
              this.rowsdata = this.drilldowndata.rowsData
              this.icons = this.drilldowndata.icons
              console.log("API Response", this.drilldowndata, this.icons)
              this.drilldownlevels = [...new Set(this.columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
              this.levels = 1
              for (var i = 1; i <= this.drilldownlevels.length; i++) {
                var value = 'level' + i
                this.levelColumns[i] = this.columns.filter(ind => ind.drilldownLevel == value)
                this.headerColumns[i] = this.levelColumns[i].map(function (el) {
                  return el.headerColumnDisplay;
                })
                this.levelicons[i] = this.icons.filter(indi => indi.drilldownLevel == value)

                console.log('WC1:', this.icons, this.columns)

                var vizletActionIconsSyspkArray = this.levelicons[i][0].actionIconsSyspkArray ? this.levelicons[i][0].actionIconsSyspkArray : []
                console.log('WC2:', vizletActionIconsSyspkArray, this.levelicons[i][0].actionIconsSyspkArray)

                this.currentMenuActionIconsData[i] = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk))
                //   console.log('WC:',vizletActionIconsSyspkArray,this.currentMenuActionIconsData,this.drilldowndata.icons)

                this.currentMenuActionIconsData[i].sort(sortFuncAI); //sorting the currentMenuActionIconsData
                console.log("actions1:",this.currentMenuActionIconsData[i],actionIconsData)
                this.iconOnChangeFlag[i] = Array(this.currentMenuActionIconsData[i].length).fill(true);

              }

              function sortFuncAI(a, b) {
                //    console.log("test sort ", a,b)
                return vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
              }

              //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
              console.log("Drilldown data level1", this.headerColumns[1])
              console.log("Drilldown data level2", this.headerColumns[2])
              console.log("Drilldown data level3", this.headerColumns[3])
              console.log("Function Call PAram ", this.funCallParamArr)
              console.log("Clickable Symbol", this.clickSymbolArr)
              var rowsDataKeys = Object.keys(this.rowsdata[0])
              this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
              this.dimSelectDpValues = this.headerColumns[1].slice(0, this.rowsDataDimKeys.length)
              console.log('Dimension variables Keys', this.rowsDataDimKeys)
              console.log('Dimension variables Keys', this.dimSelectDpValues)

              this.level1Columns = this.headerColumns[1]
              this.level2Columns = this.headerColumns[2]
              this.level3Columns = this.headerColumns[3]


              this.loadMDMRecordApproval();
              console.log("ALl mdmRecordApproval data", this.mdmRecordApproval[0].statusColour)
               this.roleName = this.$store.state.user.userRoleRestriction.roleName
              console.log("roleSwitch:", this.roleName,this.mdmRecordApproval[0].approval.approval_role)

            }, err => {
              console.log('Error Fetching data', err)
            })

      })
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      console.log("menuDetails",menuDetails);
      await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)
    }
  }
}

</script>
<style>
.first{
  color:#ffa500
}
.second{
  color:#EE4B2B
}
.third{
  color: 	  #8B0000
}
.grid-container {
  overflow-y: auto;
  height: 500px;
}
#heart {
  color: grey;
}
#heart.red {
  color: green;
}
</style>